
import { defineComponent } from 'vue';
export default defineComponent({
  name: 'DownloadCv',
  setup() {
    const publicPath = process.env.BASE_URL
    return {
      publicPath
    }
  }
})
